function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import { buildSample, generateTemplate, sanitizeParameters, parseThenSendToSheet } from '@cryptosheets/util';
import _ from 'lodash';
import { CheckCircleTwoTone, CloseCircleTwoTone, LoadingOutlined, UpCircleTwoTone, CodeOutlined, FunctionOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Button, message, notification } from 'antd';
import client from '../../feathers';
import global from './global';
var key = 'resendVerificationEmail';
export function displayMessage(_ref) {
  var {
    isSaving,
    isFinished,
    isError
  } = _ref;

  if (isSaving) {
    message.loading({
      key,
      content: 'Hang tight...'
    });
  }

  if (isFinished) {
    message.success({
      key,
      content: 'Please check your e-mail for password reset instructions.'
    });
  }

  if (isError) {
    message.error({
      key,
      content: "We had trouble sending your request. Reason: ".concat(isError && isError.message ? isError.message : 'Unknown')
    });
  }
}
export function sendVerificationEmail(_x) {
  return _sendVerificationEmail.apply(this, arguments);
}

function _sendVerificationEmail() {
  _sendVerificationEmail = _asyncToGenerator(function* (email) {
    var data = {
      action: 'resendVerifySignup',
      value: {
        email
      },
      notifierOptions: {
        preferredComm: 'email'
      }
    };
    displayMessage({
      isSaving: true,
      isFinished: false,
      isError: false
    });
    yield client.service('authManagement').create(data).catch(e => displayMessage({
      isSaving: false,
      isFinished: false,
      isError: true
    }));
    displayMessage({
      isSaving: false,
      isFinished: true,
      isError: false
    });
  });
  return _sendVerificationEmail.apply(this, arguments);
}

export function onStatusChange(status, config) {
  var constants = {
    loading: {
      key: 'status',
      message: 'Loading...',
      description: 'We are fetching your resource.',
      icon: /*#__PURE__*/React.createElement(LoadingOutlined, {
        twoToneColor: "#108ee9"
      })
    },
    success: {
      key: 'status',
      message: 'Success',
      description: 'Check the Output tab below for your data',
      icon: /*#__PURE__*/React.createElement(CheckCircleTwoTone, {
        twoToneColor: "#52c41a"
      })
    },
    error: {
      key: 'status',
      message: 'Error',
      description: 'We had trouble fetching your data. Error details in the Output collapse below.',
      icon: /*#__PURE__*/React.createElement(CloseCircleTwoTone, {
        twoToneColor: "#eb2f96"
      })
    },
    email: {
      key: 'status',
      message: 'Error',
      description: 'You have not verified your email. Click the button below to resend a verification email.',
      icon: /*#__PURE__*/React.createElement(CloseCircleTwoTone, {
        twoToneColor: "#eb2f96"
      }),
      duration: null,
      btn: /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        size: "small",
        onClick: () => sendVerificationEmail(config.email)
      }, "Send Verification Email")
    },
    quota: {
      key: 'status',
      message: 'Error',
      description: "You have exhausted your requests quota. Head to 'Settings -> Billing' to upgrade.",
      icon: /*#__PURE__*/React.createElement(UpCircleTwoTone, {
        twoToneColor: "#eb2f96"
      })
    }
  };

  if (status === 'initial') {
    return;
  }

  notification.open(constants[status]);
}
export function handleRequestError(_ref2) {
  var {
    error,
    email
  } = _ref2;

  if (error.code === 403 && error.message.includes('You have exhausted')) {
    return onStatusChange('quota');
  }

  if (error.code === 403 && error.message.includes('You have not verified')) {
    return onStatusChange('email', {
      email
    });
  }

  onStatusChange('error');
}
export var globalParameters = global.reduce((acc, param) => {
  var {
    name,
    description,
    required,
    schema,
    examples
  } = param;

  var defaultValue = _.get(examples, ['default', 'value'], null);

  var globalParamObj = {
    name,
    description,
    in: param.in,
    default: defaultValue,
    type: schema.type,
    required
  };

  if (!_.isEmpty(examples)) {
    globalParamObj.enums = _.reduce(examples, function (result, value, key) {
      var enumeration = {
        value: value.value
      };
      result.push(enumeration);
      return result;
    }, []);
  }

  acc.push(globalParamObj);
  return acc;
}, []);
export function mergeWithGlobal(parameters) {
  return sanitizeParameters(_.unionBy(parameters, globalParameters, 'name'));
}
export function replaceDefaultValues(parameters, defaultParameters) {
  var initialParameters = mergeWithGlobal(defaultParameters);

  var cleanedParameters = _.reduce(parameters, function (result, param, key) {
    result.push({
      name: param.scenarioParam,
      default: param.value
    });
    return result;
  }, []); // Find the parameter, replace the default value


  return _.unionBy(cleanedParameters, initialParameters, 'value');
}

function outputAsFunction(host, value) {
  var functionConfig = {
    endpoint: {},
    // OPTIONAL,
    customFunction: 'QUERYA',
    listSeperator: ',',
    // ",", ";", see https://exceljet.net/glossary/list-separator#:~:text=By%20default%2C%20Excel%20uses%20the,may%20use%20a%20semicolon%20(%3B).&text=Note%3A%20Excel%20automatically%20translates%20the%20separator%20in%20many%20cases.
    as: 'string',
    // "string", "R1C1", "A1"
    value
  };
  var sample = buildSample(host, functionConfig);
  return parseThenSendToSheet(sample);
}

function outputAsFields(host, value) {
  var {
    provider,
    endpoint
  } = value;
  var functionConfig = {
    endpoint: {},
    // OPTIONAL,
    customFunction: 'FIELDS',
    listSeperator: ',',
    // ",", ";", see https://exceljet.net/glossary/list-separator#:~:text=By%20default%2C%20Excel%20uses%20the,may%20use%20a%20semicolon%20(%3B).&text=Note%3A%20Excel%20automatically%20translates%20the%20separator%20in%20many%20cases.
    as: 'string',
    // "string", "R1C1", "A1"
    value: {
      provider,
      endpoint,
      _limit: 100,
      _orderBy: 'field'
    }
  };
  var sample = buildSample(host, functionConfig);
  return parseThenSendToSheet(sample);
}

function outputAsTemplate(type, endpoint, value) {
  var config = {
    endpoint,
    customFunction: 'QUERYA',
    listSeperator: ',',
    as: 'string',
    // "string", "R1C1", "A1"
    value
  };
  return generateTemplate({
    type,
    config
  });
}

export var output = (_ref3) => {
  var {
    data = {},
    endpoint = {},
    parameters = {},
    host = 'web'
  } = _ref3;
  return {
    default: {
      env: ['web', 'excel', 'sheets'],
      buttonText: 'Make Request',
      icon: /*#__PURE__*/React.createElement(CodeOutlined, null),
      handler: () => parseThenSendToSheet(data)
    },
    outputToSheet: {
      env: ['excel', 'sheets'],
      buttonText: 'Make Request (no sheet)',
      icon: /*#__PURE__*/React.createElement(CodeOutlined, null),
      handler: () => null
    },
    outputAsFunction: {
      env: ['excel', 'sheets'],
      buttonText: 'Send Function To Sheet',
      icon: /*#__PURE__*/React.createElement(FunctionOutlined, null),
      handler: () => outputAsFunction(host, parameters)
    },
    outputAsFields: {
      env: ['excel', 'sheets'],
      buttonText: 'Send Fields To Sheet',
      icon: /*#__PURE__*/React.createElement(FunctionOutlined, null),
      handler: () => outputAsFields(host, parameters)
    },
    generateTemplate: {
      env: ['excel', 'sheets'],
      buttonText: 'Generate Template',
      icon: /*#__PURE__*/React.createElement(FileExcelOutlined, null),
      handler: () => outputAsTemplate(host, endpoint, parameters)
    }
  };
};
export function splitParameters(parameters) {
  return _.partition(parameters, function (field) {
    return field.name.charAt(0) === '_';
  });
}